// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteRequestModel {
    static getAttributeTypeMap() {
        return SiteRequestModel.attributeTypeMap;
    }
}
SiteRequestModel.discriminator = undefined;
SiteRequestModel.attributeTypeMap = [
    {
        "name": "siteIds",
        "baseName": "siteIds",
        "type": "Array<number>"
    }
];
//# sourceMappingURL=siteRequestModel.js.map